import Vue from 'vue';

class LoginModalService extends Vue {
    emitLoginModal(): void {
        this.$emit('loginmodal');
    }
}

export default new LoginModalService();
